module.exports = __webpack_public_path__ + "static/media/privacy.3775d151.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/Terms_Conditions/privacy.pdf
// module id = 2478
// module chunks = 0